module.exports = __webpack_public_path__ + "img/fluorescence@2x.537aa98.jpg";